import { getIdOrNull, requestWithPromise } from '..'
import { HttpMethods, makeQueryString } from '../apiHelper'
import apiClient from './apiClient'
import { ACCESS_KEY } from './internshipRequestPortal'

const PORTAL_HOSPITAL_DEPARTMENTS = { [ACCESS_KEY]: '', institution: undefined, institutionGroup: undefined }
export const getPortalHospitalDepartments = (_, parameters = PORTAL_HOSPITAL_DEPARTMENTS) => apiClient.get(null, `public/hospital-departments${makeQueryString(parameters)}`)

export const getHospitalDepartments = (user, parameters) => {
  return requestWithPromise(
    `/api/hospital-departments${makeQueryString(parameters)}`,
    HttpMethods.GET,
    null,
    user
  )
}

export const getHospitalDepartmentSectors = (user, hospitalDepartment) => {
  return requestWithPromise(
    `/api/hospital-departments/${getIdOrNull(hospitalDepartment)}/sectors`,
    HttpMethods.GET,
    null,
    user
  )
}

export const createHospitalDepartment = (user, hospitalDepartment) => {
  return requestWithPromise(
    '/api/hospital-departments',
    HttpMethods.POST,
    hospitalDepartment,
    user
  )
}

export const deleteHospitalDepartment = (user, hospitalDepartment) => {
  return requestWithPromise(
    `/api/hospital-departments/${getIdOrNull(hospitalDepartment)}`,
    HttpMethods.DELETE,
    null,
    user
  )
}

export const linkHospitalDepartmentSectors = (user, hospitalDepartment, ids = []) => {
  return requestWithPromise(
    `/api/hospital-departments/${getIdOrNull(hospitalDepartment)}/sectors`,
    HttpMethods.POST,
    { ids },
    user
  )
}

export const updateHospitalDepartment = (user, hospitalDepartment) => {
  return requestWithPromise(
    `/api/hospital-departments/${getIdOrNull(hospitalDepartment)}`,
    HttpMethods.PATCH,
    hospitalDepartment,
    user
  )
}

export const unlinkHospitalDepartmentSectors = (user, hospitalDepartment, ids = []) => {
  return requestWithPromise(
    `/api/hospital-departments/${getIdOrNull(hospitalDepartment)}/sectors${makeQueryString({ ids })}`,
    HttpMethods.DELETE,
    null,
    user
  )
}

export const getHospitalDepartmentUsers = (user, hospitalDepartment) => {
  return requestWithPromise(
    `/api/hospital-departments/${getIdOrNull(hospitalDepartment)}/users`,
    HttpMethods.GET,
    null,
    user
  )
}

export const linkHospitalDepartmentUsers = (user, hospitalDepartment, ids = []) => {
  return requestWithPromise(
    `/api/hospital-departments/${getIdOrNull(hospitalDepartment)}/users`,
    HttpMethods.POST,
    { ids },
    user
  )
}

export const unlinkHospitalDepartmentUsers = (user, hospitalDepartment, ids = []) => {
  return requestWithPromise(
    `/api/hospital-departments/${getIdOrNull(hospitalDepartment)}/users${makeQueryString({ ids })}`,
    HttpMethods.DELETE,
    null,
    user
  )
}

export const syncHospitalDepartmentUsers = (user, hospitalDepartment) => {
  return requestWithPromise(
    `/api/hospital-departments/${getIdOrNull(hospitalDepartment)}/users/sync`,
    HttpMethods.POST,
    {},
    user
  )
}
